import React, { useState, StrictMode, useEffect } from "react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import QuizIntro from "./QuizIntro"
import style from "./quiz.module.scss"
import { QuizProvider } from "./QuizContext"
import Questionnaire from "./Questionnaire"
import { formatQuizData, sections } from "./helper"
import QuizResults from "./QuizResults"
import { getConfig } from "@/constants/config"
import { quizAnalytics, eventIds } from "./analytics"

const Quiz = ({ data: authorData }) => {
  const d = structuredClone(authorData)
  formatQuizData(d)

  const [data, setData] = useState(d)
  const [section, setSection] = useState(sections.LANDING)
  const [curQuestion, setCurQuestion] = useState(1)
  const [config, setConfig] = useState(null)

  useEffect(() => {
    getConfig()
      .then(d => {
        const { scene7BaseUrl = "", dmScene7AccountName = "" } = d.general
        setConfig({ scene7BaseUrl, dmScene7AccountName })
      })
      .catch(e => console.log(e))
  }, [])

  const contextValue = {
    setSection,
    data,
    setData,
    curQuestion,
    setCurQuestion,
    totalQuestions: data?.questions?.length,
    config,
    quizAnalytics,
    eventIds,
  }

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: Infinity,
        cacheTime: 10 * 60 * 1000,
      },
    },
  })

  let content = ""

  if (section === sections.LANDING) {
    content = <QuizIntro />
  } else if (section === sections.QUIZ) {
    content = <Questionnaire />
  } else if (section === sections.RESULTS) {
    content = <QuizResults />
  }

  return (
    config && (
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <QuizProvider value={contextValue}>
            <div className={style.quizContainer}>{content}</div>
          </QuizProvider>
        </QueryClientProvider>
      </StrictMode>
    )
  )
}

export default Quiz
